// Build the navigation `state.prefillFromEvent` payload that Journal.jsx
// reads on mount when a user clicks "Make journal note" anywhere in the
// app. Pure, testable helper.
//
// Inputs may be partial — `members` and `children` are optional. When
// missing, the function still produces a sensible body (em-dash for
// unknown child names, omits the Co-parent line entirely).
import { formatDT } from "@/lib/format";

const TYPE_LABEL = {
  custody: "Custody",
  pickup: "Pick-up",
  dropoff: "Drop-off",
  school: "School",
  holiday: "Holiday",
  call: "Phone call",
  video_call: "Video call",
  other: "Other",
};

export function buildJournalPrefillFromEvent(ev, members, children, user) {
  if (!ev) return null;
  const typeLabel = TYPE_LABEL[ev.type] || "Event";
  const childNames = (ev.child_ids || [])
    .map((cid) => (children || []).find((c) => c.id === cid)?.name)
    .filter(Boolean);
  const childLine = childNames.length ? childNames.join(", ") : "—";
  const parentMember = (members || []).find((m) => m.id === ev.parent_id);
  const isMine = parentMember && user?.id && parentMember.id === user.id;
  const coparentName = parentMember && !isMine ? parentMember.name : null;
  const dateLine = ev.start
    ? `${formatDT(ev.start)}${ev.end ? ` — ${formatDT(ev.end)}` : ""}`
    : "—";
  const lines = [
    `Related calendar event: ${ev.title || "(untitled)"}`,
    `Date/time: ${dateLine}`,
    `Type: ${typeLabel}`,
    `Child/children: ${childLine}`,
  ];
  if (coparentName) lines.push(`Co-parent: ${coparentName}`);
  lines.push("");
  lines.push("Notes:");
  lines.push("");
  return {
    sourceEventId: ev.id,
    title: `Journal note about: ${ev.title || "calendar event"}`,
    body: lines.join("\n"),
  };
}
